import {css} from 'styled-components'

import theme from '@/src/config/theme'

export const ToastifyVariables = css`
  :root {
    --toastify-color-light: #fff;
    --toastify-color-dark: #121212;
    --toastify-color-info: #3498db;
    --toastify-color-success: ${theme.colors.primary};
    --toastify-color-warning: #f1750f;
    --toastify-color-error: hsl(6, 78%, 57%);
    --toastify-color-transparent: rgba(255, 255, 255, 0.7);
  }
`
